module.exports = __webpack_public_path__ + "img/insurance.4f75801e.jpeg";